type TocItem = {
  id: string;
  text: string;
};

type TableOfContentsProps = {
  items: TocItem[];
  /** これより見出しが少ない記事では目次を出さない */
  minItems?: number;
};

export default function TableOfContents({ items, minItems = 4 }: TableOfContentsProps) {
  if (items.length < minItems) return null;

  return (
    <nav
      aria-label="目次"
      className="mt-8 rounded-[10px] border border-background-200 bg-background-100 px-5 py-5 md:px-6"
    >
      <p className="flex items-center gap-2 font-heading text-[13px] font-bold text-foreground-950">
        <i className="ri-list-check-2 text-[15px] text-primary-700" />
        目次
      </p>
      <ol className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-x-6">
        {items.map((item, index) => (
          <li key={item.id} className="flex items-start gap-2 text-[12.5px] leading-[1.85]">
            <span className="mt-[3px] shrink-0 font-heading text-[10.5px] font-bold text-primary-600">
              {String(index + 1).padStart(2, "0")}
            </span>
            <a
              href={`#${item.id}`}
              className="text-foreground-700 underline-offset-4 transition-colors duration-200 hover:text-primary-800 hover:underline"
            >
              {item.text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
}